import { customFetch } from './customFetch';

export const oathLogin = (client_id, data) =>
  customFetch('/signin/oauth2getid', 'GET', false, {
    client_id: client_id,
    data: data,
  });

export const tccsLogin = (client_id, data) =>
  customFetch('/signin/tccs-login', 'GET', false, {
    client_id: client_id,
    data: data,
  });

export const loginTest = (place_no, company_no) =>
  customFetch('/signin/token_by_place', 'GET', false, { place_no, company_no });

export const paction = (place_no, company_no) =>
  customFetch('/paction', 'GET', true, { place_no, company_no });

export const chemicaldata = (paction_no) =>
  customFetch('/paction/chemicals', 'GET', true, { paction_no: paction_no });

export const getShareLink = (paction_no, password) =>
  customFetch('/paction/pdf/generate_sharelink', 'POST', true, {
    paction_no: paction_no,
    // 只有當 password 不為 null 或 undefined 時才添加到請求體中
    ...(password ? { password: password } : {}),
  });
export const passwordUpdate = (paction_no, password) =>
  customFetch('/paction/update_password', 'POST', true, {
    paction_no: paction_no,
    password: password,
  })
export const cancelShareLink = (paction_no) =>
  customFetch('/paction/pdf/cancel_sharelink', 'POST', true, {
    paction_no: paction_no,
  });
// export const sendMail = (share_link, recipient_email, share_password,includePassword,people_ID,place_ID,certName) =>
//   customFetch('/paction/send_mail', 'POST', true, {}, {
//     share_link: share_link,
//     recipient_email: recipient_email,
//     share_password: share_password,
//     includePassword: includePassword,
//     people_ID: people_ID,
//     place_ID: place_ID,
//     certName: certName,
// });
export const sendMail = (
  share_link,
  recipient_emails,
  recipient_names,
  recipient_companies,
  share_passwords,
  includePasswords,
  people_ID,
  place_ID,
  certNames,
  recipient_company_nos,
  recipient_place_nos,
  recipient_place_names
) =>
  customFetch('/paction/send_mail', 'POST', true, {}, {
    share_link,
    recipient_emails,
    recipient_names,
    recipient_companies,
    share_passwords,
    includePasswords,
    people_ID,
    place_ID,
    certNames,
    recipient_company_nos,
    recipient_place_nos,
    recipient_place_names,
  });

export const getSharePDF = (pdf_token) =>
  customFetch('/paction/share/pdf/' + pdf_token, 'GET', false);

export const single_paction = (paction_no) =>
  customFetch('/paction/single_paction', 'GET', true, {
    paction_no: paction_no,
  });

export const getLinkPassword = (paction_no, password = null) =>
  customFetch('/paction/getlinkpassword', 'POST', true,
    { paction_no: paction_no },
    { password: password }
  );

export const getTransactionInfo = (transaction_hash, log_index) =>
  customFetch('/paction/get_transaction', 'GET', true, {
    transaction_hash: transaction_hash,
    ...(log_index !== undefined && log_index !== null ? { log_index } : {})
  });

export const getHistoricPdfUrl = (tx_hash, log_index) => {
  const rawBase = (process.env.REACT_APP_END_POINT || '/backend').replace(/\/+$/, '');
  const baseURL = rawBase.endsWith('/backend') ? rawBase : `${rawBase}/backend`;
  let url = `${baseURL}/paction/open-records/${tx_hash}/pdf`;
  if (log_index !== undefined && log_index !== null) {
    url += `?log_index=${log_index}`;
  }
  return url;
};
// 11/21 add get_basedata
export const getBasedata = (place_no, company_no) =>
  customFetch('/paction/get_basedata', 'GET', true, {
    place_no: place_no,
    company_no: company_no,
  });

export const getShareRecord = (place_no, company_no) =>
  customFetch('/paction/share_record', 'GET', true, { place_no, company_no })
    .then(res => res.data);


export const enableShareLinkFromRecord = (share_record_id) =>
  customFetch(
    '/paction/pdf/enable_sharelink_from_record',
    'POST',
    true,
    { share_record_id },
    {}
  ).then(res => res.data);

export const cancelShareLinkFromRecord = (share_record_id) =>
  customFetch(
    '/paction/pdf/cancel_sharelink_from_record',
    'POST',
    true,
    { share_record_id },
    {}
  ).then(res => res.data);

export const getEmailList = (place_no, company_no) =>
  customFetch('/recipient/email_list', 'GET', true, { place_no, company_no }).then(res => {
    return res.data;
  });

export const getEmailDetail = (email_id) =>
  customFetch('/recipient/email_detail', 'GET', true, { email_id }).then(res => res.data);

export const createEmail = (data, queryParams) =>
  customFetch('/recipient/email', 'POST', true, queryParams, data).then(res => res.data);

export const updateEmail = (email_id, data) =>
  customFetch(`/recipient/email/${email_id}`, 'PUT', true, {}, data).then(res => res.data);

export const deleteEmail = (email_id) =>
  customFetch(`/recipient/email/${email_id}`, 'DELETE', true).then(res => res.data);

export const getCompanyList = (place_no, company_no) =>
  customFetch('/recipient/company_list', 'GET', true, { place_no, company_no }).then(res => res.data);

export const getCompanyDetail = (company_id) =>
  customFetch('/recipient/company_detail', 'GET', true, { company_id }).then(res => res.data);

export const createCompany = (data, queryParams) =>
  customFetch('/recipient/company', 'POST', true, queryParams, data).then(res => res.data);

export const updateCompany = (company_id, data, queryParams) =>
  customFetch(`/recipient/company/${company_id}`, 'PUT', true, queryParams, data).then(res => res.data);

export const deleteCompany = (company_id) =>
  customFetch(`/recipient/company/${company_id}`, 'DELETE', true).then(res => res.data);

export const logOpenRecord = (token, accessor_name) =>
  customFetch(`/paction/pdf/log_open/${token}`, 'POST', false, {}, { accessor_name }).then(res => res.data);

export const getRecipientShareList = (place_no, company_no) =>
  customFetch('/paction/recipient_share_list', 'GET', true, { place_no, company_no }).then(res => res.data);